import { useUserContext } from '@issuemanager/apps/client/contexts';
import { Navigate, Outlet } from 'react-router-dom';

interface Props {
  redirectPath: string;
}

export function TypeManagerRoute({ redirectPath }: Props) {
  const { userRoles } = useUserContext();

  if (!userRoles?.hasManagedIssueTypes) {
    return <Navigate to={redirectPath} />;
  }

  return <Outlet />;
}
